import layout from '@/layout'

export default {
  path: '/marketing',
  component: layout,
  redirect: '/marketing/address',
  name: 'marketingAddress',
  meta: {
    title: 'marketing',
    icon: 'el-icon-box'
  },
  children: [
    {
      path: '/marketing/address',
      name: 'marketingAddress',
      component: () => import('@/views/address/index'),
      meta: {
        title: 'marketingAddress',
        icon: 'el-icon-box'
      }
    }
  ]
}
